export enum ExtraSelectionType {
  All = 'ALL',
  None = 'NONE',
  Selected = 'SELECTED_ONLY'
}
